import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ensureRecord, requirePermission } from '@/app/guards';
import { IMPORT_STEPS, ImportPage, importQuery } from '@/features/imports';
import { NotFoundView } from '@/features/shell';

export const Route = createFileRoute('/_app/admin_/imports/$importId')({
  staticData: { crumbParents: [{ crumb: 'nav.setup', to: '/setup' }, { crumb: 'admin:nav.imports', to: '/admin/imports' }] },
  validateSearch: z.object({ step: z.enum(IMPORT_STEPS).optional().catch(undefined) }),
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'import.run', 'Imports'),
  loader: async ({ context, params }) => {
    const b = await ensureRecord(context.queryClient.query({ ...importQuery(params.importId), staleTime: 'static' }));
    return { crumb: b.fileName };
  },
  notFoundComponent: function ImportNotFound() {
    const { importId } = Route.useParams();
    return <NotFoundView reference={importId} />;
  },
  component: function Import() {
    const { importId } = Route.useParams();
    const { step } = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <ImportPage
        importId={importId}
        step={step}
        onStepChange={(s) => void navigate({ search: { step: s } })}
        onClosed={() => void navigate({ to: '/admin/imports' })}
      />
    );
  },
});
